var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { staticClass: "emphasis" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("tenantProjects.greenFitOut.remarksToHkland")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.isHKlandUser && !_vm.remarkList.length
        ? _c("div", [_vm._v("\n    " + _vm._s(_vm.$t("emptyValue")) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.remarkList, function (remark, index) {
        return _c("div", { key: index, staticClass: "remarks-list" }, [
          _c("div", [
            _c("span", { staticClass: "remarks-list__content" }, [
              _vm._v(_vm._s(remark.remarks)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "remarks-list__text" }, [
              _vm._v(
                _vm._s(
                  "" +
                    _vm.$t("tenantProjects.submission.sentByOn", [
                      remark.createdBy.displayName,
                      _vm.dateUtil.format(
                        remark.createdAt,
                        "DD MMM YYYY HH:mm"
                      ),
                    ])
                )
              ),
            ]),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.isTenant
        ? _c(
            "HKLForm",
            {
              ref: "formRef",
              staticClass: "remarks-group",
              on: {
                change: function ($event) {
                  return _vm.formUtils.setDirty()
                },
              },
            },
            [
              _c("HKLInput", {
                directives: [
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      required: true,
                    },
                    expression:
                      "{\n        type: 'string',\n        required: true\n      }",
                  },
                ],
                staticClass: "remarks-group__input",
                model: {
                  value: _vm.inputData,
                  callback: function ($$v) {
                    _vm.inputData = $$v
                  },
                  expression: "inputData",
                },
              }),
              _vm._v(" "),
              _c("HKLButton", {
                attrs: { color: "orange", action: "send" },
                on: { click: _vm.send },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }